import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import SelectFieldSeccionesComponent from '../../secciones/components/SelectFieldSecciones';
import { allMatriculasAction } from '../MatriculasAction';
import { ALL_MATRICULAS, PARAMS_MATRICULAS } from '../MatriculasReducer';

const FiltrosMatriculasComponent = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const matriculasStore = Redux.useSelector((state) => state.matriculas);

  React.useEffect(() => {
    if (matriculasStore.params.idDocente) {
      dispatch({
        type: PARAMS_MATRICULAS,
        payload: {
          ...matriculasStore.params,
          idSeccion: null,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matriculasStore.params.idDocente]);

  const getData = async (p) => {
    if (!p) {
      dispatch({
        type: ALL_MATRICULAS,
        payload: { data: [] },
      });
    }
    const payload = {
      idEntidad: entidadesStore.activo.id,
      ...matriculasStore.params,
      ...p,
    };
    dispatch({ type: PARAMS_MATRICULAS, payload });
    await allMatriculasAction(dispatch, payload);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Typography variant="h6" color="initial">
            FILTROS
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <SelectFieldSeccionesComponent
            id="filtroSecciones"
            value={matriculasStore.params.idSeccion}
            onChange={(idSeccion) => {
              getData({
                idSeccion,
                idDocente: null,
                idMateria: null,
                idNivelAcademico: null,
              });
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FiltrosMatriculasComponent;
